import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { FarmerConsentPage } from '@contracts';

const searchSchema = z.object({
  token: z.string(),
});

export const Route = createFileRoute('/farmer-consent')({
  validateSearch: searchSchema,
  component: FarmerConsentPage,
});
